module.exports = __webpack_public_path__ + "static/media/slim_fit.bdc4deaf.svg";